export default __webpack_public_path__ + "static/media/ai-col-failed.06f84411.svg";